import styled from 'styled-components';

export const StyledQuestionInteractionBox = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 102;

  &.animated {
    .box-masked-image  {
      animation: pulse-box 1s infinite;
      animation-delay: ${() => Math.random() * 200}ms;
      transform-origin: ${(props) => props.centerPoint[0]}%
        ${(props) => props.centerPoint[1]}%;
    }
  }

  @keyframes pulse-box {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(0.97);
    }
    100% {
      transform: scale(1);
    }
  }
`;
